import axios from 'axios';

/**
 * 网站访问打点
 * @param {string} type 追中类型，如 'visit', 'order_start' 等 
 * @param {string} value 选填，具体数值或参数
 */
export const trackInfo = (type, value = '') => {
    const urlParams = new URL(window.location.href).searchParams;
    const source = urlParams.get('source') || 'direct';
    const medium = urlParams.get('medium') || '';
    const campaign = urlParams.get('campaign') || '';

    const data = {
        url: window.location.href,
        referrer: document.referrer,
        source: source,
        medium: medium,
        campaign: campaign,
        type: type,
        value: value,
        timestamp: new Date().toISOString()
    };

    return axios.post('https://apigcs.fggame.net/v1/tracking/info', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).catch(err => {
        console.error('Tracking failed:', err);
    });
};
